<template>
  <div class="container">
    <div class="row">
      <div class="col-4">
          <img :src="data.image" :alt="data.title" style="width: 100%; border-radius: 5px;">
      </div>
      <div class="col-8">
          <h3 style="font-family: 'Vidaloka', serif;"><b>{{data.title}}</b></h3>
          <div style="display: flex; ">
            <p style="font-size: 14px;background: #1c1c1c; padding: 10px 12px; border-radius: 5px; margin-right: 5px;"><i class="fas fa-calendar"></i> <b>{{data.start_date | moment("MMMM Do YYYY")}} {{data.start_time | moment("hh:mm a")}}</b></p>
            <p style="padding: 10px 10px; border-radius: 5px; margin-right: 5px;"><b>to</b></p>
            <p style="font-size: 14px;background: #1c1c1c; padding: 10px 12px; border-radius: 5px;"> <i class="fas fa-clock"></i> <b>{{data.end_date | moment("MMMM Do YYYY")}}  {{data.end_time | moment("hh:mm a")}}</b></p>
          </div>
          <div style="display: flex ;margin-bottom: 20px; justify-content: space-between;">
              <div>
                <a :href="'/e/' + this.event" target="_blank" class="btn btn-primary btn-sm mr-2">View</a>
              </div>
              <div>
                <router-link class="btn btn-outline-primary btn-sm" :to="'/e/' + data.event_id + '/edit'">
                  Edit
                </router-link>
                <button class="btn btn-danger btn-sm ml-2" data-toggle="modal" data-target="#deleteDialog" @click="delete_event = e">Delete</button>
              </div>
          </div>
      </div>
    </div>
    <div class="row">
        <v-tabs
              background-color=""
              class="elevation-2 d-none d-md-block"
              dark
              height="40px"
              :grow="true"
              :icons-and-text="true"
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab key="details" :href="`#details`" style="color: #FFB229;font-size: 10px">
                Details
              </v-tab>
              <v-tab key="users" :href="`#users`" style="color: #FFB229;font-size: 10px">
                Registered Users
              </v-tab>
              <v-tab key="recordings" :href="`#recordings`" style="color: #FFB229;font-size: 10px">
                Recordings
              </v-tab>

              <v-tab-item key="details" value="details">
                <v-card flat tile style="background: #000;color: #fff">
                  <!-- <home class="container-fluid"></home> -->
                  <div class="row">
                    <div class="col-12" style="margin: 5% 0;">
                      <h5><b>About Event</b></h5>
                      <p v-html="data.long_desc"></p>
                    </div>
                    <div class="col-12" v-if="data.sponsors.length > 0">
                      <h5><b>Sponsors</b></h5>
                      <table class="table" style="color:#fff;">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Message</th>
                            <th>Link</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr  v-for="(s, i) in data.sponsors" :key="i">
                            <td>{{i+1}}</td>
                            <td><img :src="s.sponsor_img" alt="" style="border-radius: 50%; height: 20px; width: 20px; margin: 2%"> {{s.sponsor_name}}</td>
                            <td style="max-width:250px;">{{s.sponsor_message}}</td>
                            <td><a class="btn btn-primary btn-sm" :href="s.sponsor_website + '?utm_source=meetbeans.com&&utm_event='+data.title" target="_blank">Visit</a></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-12" style="margin: 5% 0;" v-if="data.speakers.length > 0">
                      <h4><b>Speakers</b></h4>
                      <table class="table" style="color:#fff;">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Bio</th>
                            <th>is_keynote</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr  v-for="(u, index) in data.speakers" :key="index">
                            <td>{{index+1}}</td>
                            <td><img :src="u.photoURL" alt="" style="border-radius: 50%; height: 20px; width: 20px; margin: 2%"> {{u.name}}</td>
                            <td>{{u.designation}} - {{u.company}}</td>
                            <td>{{u.bio}}</td>
                            <td>{{u.is_keynote}}</td>
                          </tr>
                        </tbody>
                      </table>
                      
                    </div>
                    <div class="col-12">
                      <div>
                        <h5><b>Agenda</b></h5>
                      </div>
                      <div class="row" v-for="(s, i) in data.sessions" :key="i">
                        <div class="col-12 col-md-12">
                          <div class="card mb-2">
                            <div class="card-body">
                              <div class="row">
                                <div class="col-12 col-md-2" style="text-align: -moz-center;text-align: -webkit-center;">
                                  <figure :data-letters="i+1" style="font-weight: bold; height: 80px; width: 80px;"></figure>
                                </div>
                                <div class="col-12 col-md-10">
                                  <h4 class="mb-0"><b>{{s.session_name}}</b></h4>
                                  <span v-for="(u, index) in s.speakers" :key="index"><span v-if="index!==0">,</span> {{u.name}} </span>
                                  <p class="text-muted">{{s.session_description}}</p>
                                  <small style="margin-top: 15px;">Capacity: {{s.participants}} Seats</small>
                                  <router-link :to="'/event/' + data.event_id + '/agenda/' + s.session_id" class="btn btn-primary float-right" v-if="data.registered_status === 'REGISTERED' && data.status === 'Live'">Enter In Auditorium</router-link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-tab-item>
              <v-tab-item key="users" value="users">
                <v-card flat tile style="background: #000;color: #fff">
                  <attendees class="container-fluid" style="margin: 5% 0;" :event="this.event"></attendees>
                </v-card>
              </v-tab-item>
              <v-tab-item key="recordings" value="recordings">
                <v-card flat tile style="background: #000;color: #fff">
                  <recordings :event="event" style="margin: 5% 0;"></recordings>
                </v-card>
              </v-tab-item>
            </v-tabs>
    </div>
    <div
      class="modal"
      id="deleteDialog"
      tabindex="-1"
      role="dialog"
      aria-labelledby="deleteDialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body text-center">
            <h1><i class="fas fa-question"></i></h1>
            <p style="margin-bottom: 2px;"><b>Are your sure?</b></p>
            <p>This action will delete all details</p>
            <button
              type="button"
              class="btn btn-danger"
              @click="deleteEventFunction()"
            >
              Yes, delete it.
            </button>
            <button
              type="button"
              class="ml-2 btn btn-primary"
              id="close-deleteDialog"
              data-dismiss="modal"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Recordings from "@/components/dashboard/recordings.vue";
import attendees from "@/components/dashboard/event-attendees.vue";
import Swal from 'sweetalert2';

export default {
  name: "fullEventDetails",
  components: {
      Recordings,
      attendees
  },
  props: ['event'],
  data() {
      return {
          data: {},
          user: {}
      }
  },
  created() {
      this.getEventData();
      if (localStorage.getItem('user_info')) {
        this.user = JSON.parse(localStorage.getItem('user_info'))
      }
    },
  methods: {
      deleteEventFunction: function() {
      const $ = this;
      // console.log(this.delete_event)
      this.$store
        .dispatch("deleteEvent", this.event)
        .then((resp) => {
          if (resp.data.status === "success") {
              Swal.fire("Event has been successfully deleted").then( result => {
                  if(result.value) {
                      document.getElementById("close-deleteDialog").click();
                      $.$router.push("/dashboard");
                  }
              })
          }
        });
    },
      getEventData () {
        let data = {
          "event_id": this.event
        }
        this.$store.dispatch('getEventDetail', data).then(resp => {
          if (resp.data.status === "success") {
			this.data = resp.data.data
			console.log(this.data)
          } else {
            this.$toast.open({
              message: resp.data.data,
              type: 'success',
			  position: 'top',
			  queue: true
            });
          }
        })
      },
  }
};
</script>
<style lang="scss" scoped></style>
